import { useQuery } from "@tanstack/react-query";
import useApiHelper from "../hooks/useApiHelper";
import { IAccount } from "../models/account/IAccount";
import { DefaultResponseWithData } from "../models/system";
import apiConfig from "../utils/apiConfig";

export default function useFlowTypeAccounts(componentName = "useFlowTypeAccounts") {
  const { get } = useApiHelper(apiConfig(componentName));

  const flowTypeAccounts = useQuery({
    queryKey: ["accounts", "flow-types"],
    queryFn: () => get<DefaultResponseWithData<IAccount[]>>("/account/flow-types"),
    staleTime: 1000 * 60 * 10,
  });

  return {
    flowTypeAccounts,
  };
}
